import { render } from "./InputProperties.vue?vue&type=template&id=b40712f0"
import script from "./InputProperties.vue?vue&type=script&lang=js"
export * from "./InputProperties.vue?vue&type=script&lang=js"

import "./InputProperties.vue?vue&type=style&index=0&id=b40712f0&lang=css"

import exportComponent from "/app/tmp/blackhall/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__